import React from 'react'

import { useMainQueryData } from './useMainQueryData'

export const useMainQueryQuestions = () => {
  const survey = useMainQueryData()

  return React.useMemo(() => survey?.questions ?? [], [survey?.questions])
}
